const state = {
  all: []
}

const mutations = {
  updateMonitoresList (state, res) {
    state.all = res.data
  }
}

const actions = {
  listMonitores(context) {
    return window.axios.get('/api/v2/monitores').then((res) => {
      context.commit('updateMonitoresList', res)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Monitores.js